import { useMemo } from 'react';

var calculateHeight = function calculateHeight(itemHeight, amountItemsInWindow, itemsLength) {
  var realAmountItemsInWindow = itemsLength < amountItemsInWindow ? itemsLength : amountItemsInWindow;
  return itemHeight * realAmountItemsInWindow;
};

function useHeightByAmountOfItems(_ref) {
  var itemHeight = _ref.itemHeight,
      amountItems = _ref.amountItems,
      items = _ref.items;
  var calculatedHeight = useMemo(function () {
    return calculateHeight(itemHeight, amountItems, items.length);
  }, [amountItems, items]);
  return calculatedHeight;
}

export default useHeightByAmountOfItems;
//# sourceMappingURL=useHeightByAmountOfItems.js.map
